import React, { useMemo, useState } from 'react';
import { Search, Map } from 'lucide-react';
import { SearchFilters } from '../components/SearchFilters';
import { PlotCard } from '../components/PlotCard';
import { Link } from 'react-router-dom';
import { PersonaSwitcher } from '../components/PersonaSwitcher';
import { Footer } from '../components/Footer';
import { FloatingPersonaSwitcher } from '../components/FloatingPersonaSwitcher';
export function HomePage() {
  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useState('newest');
  const [filters, setFilters] = useState({
    budgetMin: '',
    budgetMax: '',
    locationType: [] as string[],
    plotSize: '',
    legalStatus: [] as string[]
  });
  const plots = [{
    id: '1',
    title: 'Premium Corner Plot in Hinjewadi Phase 1',
    location: 'Pune, Maharashtra',
    size: '2,400 Sq. Ft',
    price: '₹ 45 Lakhs',
    priceValue: 45,
    trustLevel: 'verified' as const,
    dateAdded: new Date('2024-01-15')
  }, {
    id: '2',
    title: 'Residential Land near Airport Road',
    location: 'Bangalore, Karnataka',
    size: '1,200 Sq. Ft',
    price: '₹ 85 Lakhs',
    priceValue: 85,
    trustLevel: 'partial' as const,
    dateAdded: new Date('2024-01-10')
  }, {
    id: '3',
    title: 'Gated Community Plot - Sector 45',
    location: 'Gurgaon, Haryana',
    size: '3,000 Sq. Ft',
    price: '₹ 2.1 Cr',
    priceValue: 210,
    trustLevel: 'verified' as const,
    dateAdded: new Date('2024-01-20')
  }, {
    id: '4',
    title: 'Investment Plot - Developing Zone',
    location: 'Nagpur, Maharashtra',
    size: '5,000 Sq. Ft',
    price: '₹ 25 Lakhs',
    priceValue: 25,
    trustLevel: 'caution' as const,
    dateAdded: new Date('2024-01-08')
  }, {
    id: '5',
    title: 'Lake View Plot - Whitefield Extension',
    location: 'Bangalore, Karnataka',
    size: '1,500 Sq. Ft',
    price: '₹ 65 Lakhs',
    priceValue: 65,
    trustLevel: 'verified' as const,
    dateAdded: new Date('2024-01-18')
  }, {
    id: '6',
    title: 'Commercial Zone Land Parcel',
    location: 'Hyderabad, Telangana',
    size: '10,000 Sq. Ft',
    price: '₹ 5.5 Cr',
    priceValue: 550,
    trustLevel: 'verified' as const,
    dateAdded: new Date('2024-01-12')
  },
  // Gujarat Plots
  {
    id: '7',
    title: 'Premium Residential Plot in Satellite',
    location: 'Ahmedabad, Gujarat',
    size: '2,000 Sq. Ft',
    price: '₹ 55 Lakhs',
    priceValue: 55,
    trustLevel: 'verified' as const,
    dateAdded: new Date('2024-01-14')
  }, {
    id: '8',
    title: 'Commercial Land near GIFT City',
    location: 'Gandhinagar, Gujarat',
    size: '3,500 Sq. Ft',
    price: '₹ 1.2 Cr',
    priceValue: 120,
    trustLevel: 'verified' as const,
    dateAdded: new Date('2024-01-16')
  }, {
    id: '9',
    title: 'Gated Villa Plot - Shela Road',
    location: 'Ahmedabad, Gujarat',
    size: '2,800 Sq. Ft',
    price: '₹ 72 Lakhs',
    priceValue: 72,
    trustLevel: 'verified' as const,
    dateAdded: new Date('2024-01-11')
  }, {
    id: '10',
    title: 'Industrial Land Parcel - Vatva GIDC',
    location: 'Ahmedabad, Gujarat',
    size: '8,000 Sq. Ft',
    price: '₹ 2.8 Cr',
    priceValue: 280,
    trustLevel: 'partial' as const,
    dateAdded: new Date('2024-01-09')
  }, {
    id: '11',
    title: 'Beach View Plot - Dumas Road',
    location: 'Surat, Gujarat',
    size: '1,800 Sq. Ft',
    price: '₹ 48 Lakhs',
    priceValue: 48,
    trustLevel: 'verified' as const,
    dateAdded: new Date('2024-01-17')
  }, {
    id: '12',
    title: 'Residential Plot in Adajan',
    location: 'Surat, Gujarat',
    size: '1,500 Sq. Ft',
    price: '₹ 42 Lakhs',
    priceValue: 42,
    trustLevel: 'verified' as const,
    dateAdded: new Date('2024-01-13')
  }, {
    id: '13',
    title: 'Farm Land near Statue of Unity',
    location: 'Kevadia, Gujarat',
    size: '12,000 Sq. Ft',
    price: '₹ 35 Lakhs',
    priceValue: 35,
    trustLevel: 'partial' as const,
    dateAdded: new Date('2024-01-07')
  }, {
    id: '14',
    title: 'Corner Plot in Kalawad Road',
    location: 'Rajkot, Gujarat',
    size: '2,200 Sq. Ft',
    price: '₹ 38 Lakhs',
    priceValue: 38,
    trustLevel: 'verified' as const,
    dateAdded: new Date('2024-01-19')
  }, {
    id: '15',
    title: 'Premium Plot near Dwarka Temple',
    location: 'Dwarka, Gujarat',
    size: '1,600 Sq. Ft',
    price: '₹ 28 Lakhs',
    priceValue: 28,
    trustLevel: 'verified' as const,
    dateAdded: new Date('2024-01-06')
  }, {
    id: '16',
    title: 'Investment Land - Dholera SIR',
    location: 'Dholera, Gujarat',
    size: '6,000 Sq. Ft',
    price: '₹ 45 Lakhs',
    priceValue: 45,
    trustLevel: 'caution' as const,
    dateAdded: new Date('2024-01-21')
  }, {
    id: '17',
    title: 'Residential Plot in Vesu',
    location: 'Surat, Gujarat',
    size: '2,500 Sq. Ft',
    price: '₹ 68 Lakhs',
    priceValue: 68,
    trustLevel: 'verified' as const,
    dateAdded: new Date('2024-01-05')
  }, {
    id: '18',
    title: 'Commercial Plot - CG Road',
    location: 'Ahmedabad, Gujarat',
    size: '4,000 Sq. Ft',
    price: '₹ 1.8 Cr',
    priceValue: 180,
    trustLevel: 'verified' as const,
    dateAdded: new Date('2024-01-22')
  }];
  const filteredAndSortedPlots = useMemo(() => {
    let result = plots.filter(plot => {
      if (searchQuery) {
        const query = searchQuery.toLowerCase();
        const matchesSearch = plot.title.toLowerCase().includes(query) || plot.location.toLowerCase().includes(query);
        if (!matchesSearch) return false;
      }
      // Budget filter
      const priceInLakhs = plot.priceValue;
      if (filters.budgetMin && priceInLakhs < parseFloat(filters.budgetMin)) {
        return false;
      }
      if (filters.budgetMax && priceInLakhs > parseFloat(filters.budgetMax)) {
        return false;
      }
      // Plot size filter
      if (filters.plotSize) {
        const sizeValue = parseFloat(plot.size.replace(/[^0-9]/g, ''));
        if (filters.plotSize === 'Under 1,000' && sizeValue >= 1000) return false;
        if (filters.plotSize === '1,000 - 2,000' && (sizeValue < 1000 || sizeValue > 2000)) return false;
        if (filters.plotSize === '2,000 - 5,000' && (sizeValue < 2000 || sizeValue > 5000)) return false;
        if (filters.plotSize === '5,000+' && sizeValue < 5000) return false;
      }
      // Location Type filter
      if (filters.locationType.length > 0) {
        const urbanCities = ['Pune', 'Bangalore', 'Gurgaon', 'Hyderabad', 'Ahmedabad', 'Surat', 'Rajkot', 'Gandhinagar'];
        const periUrbanAreas = ['Hinjewadi', 'Whitefield', 'Satellite', 'Shela', 'Adajan', 'Vesu', 'Dholera', 'Kalawad'];
        const ruralAreas = ['Nagpur', 'Kevadia', 'Dwarka', 'Mulshi'];
        const location = plot.location.toLowerCase();
        const title = plot.title.toLowerCase();
        let matchesLocationType = false;
        if (filters.locationType.includes('Urban / City Limits')) {
          matchesLocationType = matchesLocationType || urbanCities.some(city => location.includes(city.toLowerCase()));
        }
        if (filters.locationType.includes('Peri-urban')) {
          matchesLocationType = matchesLocationType || periUrbanAreas.some(area => location.includes(area.toLowerCase()) || title.includes(area.toLowerCase()));
        }
        if (filters.locationType.includes('Rural / Agricultural')) {
          matchesLocationType = matchesLocationType || ruralAreas.some(area => location.includes(area.toLowerCase())) || title.includes('farm');
        }
        if (!matchesLocationType) return false;
      }
      // Legal Status filter
      if (filters.legalStatus.length > 0) {
        let matchesLegalStatus = false;
        if (filters.legalStatus.includes('RERA Registered') || filters.legalStatus.includes('NA Converted')) {
          matchesLegalStatus = matchesLegalStatus || plot.trustLevel === 'verified';
        }
        if (filters.legalStatus.includes('Collector Approved')) {
          matchesLegalStatus = matchesLegalStatus || plot.trustLevel === 'partial';
        }
        if (filters.legalStatus.includes('Gram Panchayat')) {
          matchesLegalStatus = matchesLegalStatus || plot.trustLevel === 'caution';
        }
        if (!matchesLegalStatus) return false;
      }
      return true;
    });
    if (sortBy === 'price-low') {
      result.sort((a, b) => a.priceValue - b.priceValue);
    } else if (sortBy === 'price-high') {
      result.sort((a, b) => b.priceValue - a.priceValue);
    } else if (sortBy === 'newest') {
      result.sort((a, b) => b.dateAdded.getTime() - a.dateAdded.getTime());
    }
    return result;
  }, [searchQuery, filters, sortBy, plots]);
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
  };
  const handleResetFilters = () => {
    setFilters({
      budgetMin: '',
      budgetMax: '',
      locationType: [],
      plotSize: '',
      legalStatus: []
    });
    setSearchQuery('');
    setSortBy('newest');
  };
  return <div data-testid="home-page" className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-4157">
      <header data-testid="home-header" className="bg-white border-b border-gray-300 py-4 px-6 md:px-12 flex justify-between items-center sticky top-0 z-10" data-id="element-4158">
        <Link data-testid="home-logo-link" to="/" className="flex items-center gap-2" data-id="element-4159">
          <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-4160"></div>
          <span className="font-bold text-xl tracking-tight" data-id="element-4161">
            Citiplots.com
          </span>
        </Link>
        <nav data-testid="home-nav" className="hidden md:flex gap-8 text-sm font-medium text-gray-600" data-id="element-4162">
          <Link data-testid="home-nav-buy-link" to="/" className="text-[#1f2933]" data-id="element-4163">
            Buy Plots
          </Link>
          <Link data-testid="home-nav-auctions-link" to="/auctions" data-id="element-4164">
            Auctions
          </Link>
          <Link data-testid="home-nav-sell-link" to="/create-listing" data-id="element-4165">
            Sell Land
          </Link>
          <Link data-testid="home-nav-legal-link" to="/legal-guides" data-id="element-4166">
            Legal Guides
          </Link>
          <Link data-testid="home-nav-advocacy-link" to="/advocacy" data-id="element-4167">
            Advocacy
          </Link>
        </nav>
        <div className="flex items-center gap-4" data-id="element-4168">
          <Link data-testid="home-post-listing-btn" to="/create-listing" className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-4169">
            Post Listing
          </Link>
        </div>
      </header>

      <section data-testid="home-hero" className="bg-white border-b border-gray-300 py-16 px-6 md:px-12 text-center" data-id="element-4170">
        <h1 data-testid="home-hero-title" className="text-4xl md:text-5xl font-bold mb-4 tracking-tight" data-id="element-4171">
          India's Direct Plot Transaction Portal
        </h1>
        <p data-testid="home-hero-subtitle" className="text-lg text-gray-500 mb-8 max-w-2xl mx-auto font-mono" data-id="element-4172">
          Zero intermediaries. 100% verified documentation. Transparent pricing.
        </p>

        <form data-testid="home-search-form" onSubmit={handleSearch} className="max-w-3xl mx-auto flex flex-col md:flex-row gap-2" data-id="element-4173">
          <div className="flex-1 relative" data-id="element-4174">
            <Map className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" data-id="element-4175" />
            <input data-testid="home-search-input" type="text" placeholder="Search by City, Locality, or Project..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-12 pr-4 py-4 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500 font-mono text-sm" data-id="element-4176" />
          </div>
          <button data-testid="home-search-btn" type="submit" className="px-8 py-4 bg-[#1f2933] text-white font-bold flex items-center justify-center gap-2 hover:bg-gray-800" data-id="element-4177">
            <Search className="w-5 h-5" data-id="element-4178" />
            Search Plots
          </button>
        </form>
      </section>

      <main data-testid="home-main" className="flex-1 max-w-7xl mx-auto px-4 md:px-6 py-8" data-id="element-4179">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8" data-id="element-4180">
          <aside data-testid="home-filters-sidebar" className="hidden md:block md:col-span-3" data-id="element-4181">
            <SearchFilters filters={filters} setFilters={setFilters} onReset={handleResetFilters} data-id="element-4182" />
          </aside>

          <div data-testid="home-results" className="md:col-span-9" data-id="element-4183">
            <div data-testid="home-results-header" className="flex justify-between items-center mb-6" data-id="element-4184">
              <h2 data-testid="home-results-count" className="text-xl font-bold" data-id="element-4185">
                Showing {filteredAndSortedPlots.length} Verified Plots
              </h2>
              <div className="flex items-center gap-2 text-sm font-mono text-gray-500" data-id="element-4186">
                <span data-id="element-4187">Sort by:</span>
                <select data-testid="home-sort-select" value={sortBy} onChange={e => setSortBy(e.target.value)} className="bg-transparent border-none font-bold text-[#1f2933] cursor-pointer focus:ring-0" data-id="element-4188">
                  <option value="newest" data-id="element-4189">Newest First</option>
                  <option value="price-low" data-id="element-4190">Price: Low to High</option>
                  <option value="price-high" data-id="element-4191">Price: High to Low</option>
                </select>
              </div>
            </div>

            {filteredAndSortedPlots.length > 0 ? <>
                <div data-testid="home-results-grid" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-4192">
                  {filteredAndSortedPlots.map(plot => <PlotCard key={plot.id} {...plot} data-id="element-4193" />)}
                </div>

                <div data-testid="home-load-more-section" className="mt-12 flex justify-center" data-id="element-4194">
                  <button data-testid="home-load-more-btn" className="px-6 py-3 border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50" data-id="element-4195">
                    Load More Listings
                  </button>
                </div>
              </> : <div data-testid="home-no-results" className="text-center py-16 border-2 border-dashed border-gray-300 bg-gray-50" data-id="element-4196">
                <Search className="w-12 h-12 text-gray-300 mx-auto mb-4" data-id="element-4197" />
                <h3 className="font-bold text-gray-500 mb-2" data-id="element-4198">No plots found</h3>
                <p className="text-sm text-gray-400 font-mono mb-4" data-id="element-4199">
                  Try adjusting your search or filters
                </p>
                <button data-testid="home-reset-filters-btn" onClick={handleResetFilters} className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-4200">
                  Reset All Filters
                </button>
              </div>}
          </div>
        </div>
      </main>

      <Footer data-id="element-4201" />
      <FloatingPersonaSwitcher data-id="element-4202" />
    </div>;
}